import axios from 'axios'

if (localStorage.getItem('accessToken')) {
    axios.defaults.headers.common.authorization = 'Bearer ' + localStorage.getItem('accessToken')
}

axios.defaults.headers.common['x-api-token'] = process.env.VUE_APP_TOKEN

export default axios
